var render = function render(){var _vm=this,_c=_vm._self._c;return _c('user-survey-form',{staticClass:"mb-4",attrs:{"busy":_vm.busy,"surveys":_vm.surveys,"userSurveys":_vm.userSurveys},on:{"surveyUpdated":_vm.onSurveyUpdated}})
}
var staticRenderFns = []

export { render, staticRenderFns }